var $d791c4a431b7a587$exports = {};
$d791c4a431b7a587$exports = {
  "alert": "\uACBD\uACE0",
  "dismiss": "\uBB34\uC2DC"
};
export { $d791c4a431b7a587$exports as default };